import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  wfhs: [], // Initial wfhs array
  isPunchedOut: false,
  showPunchWarning: false,
};

const wfhSlice = createSlice({
  name: 'wfh',
  initialState,
  reducers: {
    setWfhs: (state, action) => {
      state.wfhs = action.payload;
    },
    addWfh: (state, action) => {
      state.wfhs.unshift(action.payload);
    },
    updateWfh: (state, action) => {
      const updatedWfh = action.payload;

      state.wfhs = state.wfhs.map((prevWfh) =>
        prevWfh.id === updatedWfh.id ? updatedWfh : prevWfh
      );
    },
    deleteWfh: (state, action) => {
      const wfhIndex = state.wfhs.findIndex(
        (wfh) => wfh.id === action.payload
      );
      if (wfhIndex !== -1) {
        state.wfhs.splice(wfhIndex, 1);
      }
    },
    setIsPunchedOut: (state, action) => {
      state.isPunchedOut = action.payload;
    },
    setShowPunchWarning: (state, action) => {
      state.showPunchWarning = action.payload;
    },
  },
});

export const {
  setWfhs,
  addWfh,
  updateWfh,
  deleteWfh,
  setIsPunchedOut,
  setShowPunchWarning,
} = wfhSlice.actions;

export default wfhSlice.reducer;